import axios, { AxiosRequestHeaders } from 'axios';

const SESSION_TOKEN_KEY = 'gcm.sessionToken';

export const apiBaseUrl = process.env.REACT_APP_API_URL ?? '';

export const getStoredSessionToken = (): string | null => {
  return window.localStorage.getItem(SESSION_TOKEN_KEY);
};

export const setStoredSessionToken = (token: string): void => {
  window.localStorage.setItem(SESSION_TOKEN_KEY, token);
};

export const clearStoredSessionToken = (): void => {
  window.localStorage.removeItem(SESSION_TOKEN_KEY);
};

axios.interceptors.request.use((config) => {
  const headers = (config.headers ?? {}) as AxiosRequestHeaders;
  const sessionToken = getStoredSessionToken();
  const authorization = headers.Authorization ?? headers.authorization;

  if (sessionToken) {
    headers['X-GCM-Token'] = sessionToken;
  }

  if (typeof authorization === 'string' && authorization.startsWith('Basic ')) {
    delete headers.Authorization;
    delete headers.authorization;
  }

  config.headers = headers;

  return config;
});

export default axios;
